"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var Sentry = __importStar(require("@sentry/react"));
var Model_1 = require("./Model");
var App_1 = require("./App");
var DataStore_1 = require("./data/DataStore");
var Gate_1 = require("./lib/gate/Gate");
var data_1 = require("./data/data");
var getParameterByName_1 = require("./lib/functions/getParameterByName");
var Bridge_1 = require("./Bridge");
var body_css_class = (0, getParameterByName_1.getParameterByName)("body_css_class");
function getJson() {
    if (window.post_json_data) {
        return window.post_json_data;
    }
    else {
        return {};
    }
}
if (body_css_class) {
    document.body.classList.add(body_css_class);
    window.isPdf = !!body_css_class.includes("pdf");
}
var dataStore = new DataStore_1.DataStore(data_1.json);
var gate = new Gate_1.Gate();
var model = new Model_1.Model(gate, dataStore);
window.model = model;
model.form_id = window.post_form_id || (0, getParameterByName_1.getParameterByName)("form_id") || "";
model.json_data = getJson();
model.task = window.task;
model.completedUrl = window.completedUrl;
model.cancelUrl = window.cancelUrl;
model.studentData = window.studentData;
model.taskUserInfo = window.taskUserInfo;
model.definedUserId = window.definedUserId;
model.token = window.token;
model.sl = window.sl;
model.taskUserId = window.taskUserId || 0;
model.profileId = window.profileId || "3";
console.log("++++++++++++++");
console.log(JSON.stringify(window.post_json_data));
console.log(JSON.stringify(model.json_data));
console.log("++++++++++++++");
window.pdf = new Bridge_1.Bridge(model);
Sentry.init({
    dsn: "https://a128a08bb6f14ade98a48ed96c12358b@o690016.ingest.sentry.io/5774388"
});
ReactDOM.render(React.createElement(App_1.App, { model: model }), document.getElementById("root"));
//# sourceMappingURL=data:application/json;base64,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